<script>
import { isEmpty } from '../../../../utils'
import { lookupRelationshipProps, initValue } from '../index'

export default {
  name: 'master-read-relationship',
  props: lookupRelationshipProps,
  render () {
    const value = initValue(this.value, 'showContent')
    const props = {
      showTooltip: this.showTooltip,
      linkOperationApiName: this.linkOperationApiName,
      linkObjectApiName: this.linkObjectApiName,
      tenantType: this.tenantType,
      id: this.value?.id || this.id,
      value
    }
    return (
      isEmpty(value) ? <span>-</span> : <jump {...{props}}></jump>
    )
  }
}
</script>